import { userInfoSync } from 'hub-http/userInfo';
export function useDealPlanPermissions({
  skipScopeCheck = false
} = {}) {
  var _userInfoSync$user, _scopes$includes, _scopes$includes2;
  if (skipScopeCheck) {
    return {
      canWritePlan: true,
      canWriteMilestone: true
    };
  }
  const scopes = (_userInfoSync$user = userInfoSync().user) === null || _userInfoSync$user === void 0 ? void 0 : _userInfoSync$user.scopes;
  return {
    canWritePlan: (_scopes$includes = scopes === null || scopes === void 0 ? void 0 : scopes.includes('deal-plan-write')) !== null && _scopes$includes !== void 0 ? _scopes$includes : false,
    canWriteMilestone: (_scopes$includes2 = scopes === null || scopes === void 0 ? void 0 : scopes.includes('deal-plan-milestone-write')) !== null && _scopes$includes2 !== void 0 ? _scopes$includes2 : false
  };
}